import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { TableModule } from "primeng/table";
import { SharedModule } from "../shared/shared.module";
import { NotificationEntryComponent } from "./notification-entry/notification-entry.component";
import { NotificationListComponent } from "./notification-list/notification-list.component";
import { NotificationPageComponent } from "./notification-page/notifications-page.component";
import { SystemNotificationListComponent } from "ng/src/app/notifications/system-notification-list/system-notification-list.component";
import { DualNotificationContainerComponent } from "ng/src/app/notifications/dual-notification-container/dual-notification-container.component";
import { CardModule } from "primeng/card";
import { SelectButtonModule } from "primeng/selectbutton";
import { FormsModule } from "@angular/forms";
import { TabViewModule } from "primeng/tabview";
import { NotificationButtonComponent } from "ng/src/app/notifications/notification-button/notification-button.component";
import { BadgeModule } from "primeng/badge";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { SystemNotificationEntryComponent } from "ng/src/app/notifications/system-notification-entry/system-notification-entry.component";

@NgModule({
	declarations: [
		NotificationPageComponent,
		NotificationListComponent,
		NotificationEntryComponent,
		SystemNotificationListComponent,
		DualNotificationContainerComponent,
		NotificationButtonComponent,
		SystemNotificationEntryComponent
	],
	exports: [
		SystemNotificationListComponent,
		NotificationListComponent,
		DualNotificationContainerComponent,
		NotificationButtonComponent,
		SystemNotificationEntryComponent
	],
	imports: [
		CommonModule,
		TableModule,
		ButtonModule,
		SharedModule,
		CardModule,
		SelectButtonModule,
		FormsModule,
		TabViewModule,
		BadgeModule,
		OverlayPanelModule
	]
})
export class NotificationModule { }